import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import ScrollIntoView from "../../../shared/scroll-into-view/scroll-into-view";
import { fetchCostumes } from "./../../accessories/costumes/ducks/actions";
import {
  addCostumeToScene,
  clearRedirect
} from "./ducks/actions";
import Form from "./form";
import Loader from "../../../shared/loader";

function AddVisualEffectToScene(props) {
  const { filmId, sceneId } = props.match.params;
  const {
    fetchCostumes,
    addCostumeToScene,
    clearRedirect,
    errors,
    costumes,
    sceneCostumes,
    saving,
    costume
  } = props;

  const [fromBreakdown, setFromBreakdown] = useState<boolean>(false);
  useEffect(() => {
    setFromBreakdown(props.location?.state?.fromBreakdown);
  }, [props.location?.state?.fromBreakdown]);

  useEffect(() => {
    fetchCostumes(filmId);
  }, []);

  if (props.redirect) {
    clearRedirect();
    if (props.redirect.to == "list") {
      const url = `/films/${filmId}/scenes/${sceneId}/costumes`;
      return <Redirect to={url} />;
    } else if (props.redirect.to == "breakdown") {
      const url = `/films/${filmId}/breakdown/scenes/${sceneId}`;
      return <Redirect to={url} />;
    }
  }

  function onAddCostume(costume) {
    sanitiseDataTypes(costume);
    addCostumeToScene(filmId, sceneId, costume, fromBreakdown);
  }

  function sanitiseDataTypes(setDressing) {
  }

  const sceneCostumeIds = sceneCostumes.map(p => p.id);
  const nonSceneCostumes = costumes.filter((costume: any) => !sceneCostumeIds.includes(costume.id));

  return (
    <ScrollIntoView
      className="blade-content"
      path="/films/:filmId/scenes/:sceneId/costumes/add"
      loading={false}>
      <Form
        mode="add"
        errors={errors}
        initialValues={costume}
        costumes={nonSceneCostumes}
        onSubmit={onAddCostume}
      />
      {saving && <Loader />}
    </ScrollIntoView>
  );
}

function mapStateToProps(state) {
  const { costumeState } = state.scenesState;
  return {
    sceneCostumes: costumeState.costumes,
    costumes: state.costumesState.costumes,
    costume: costumeState.costume,
    errors: costumeState.errors,
    redirect: costumeState.redirect,
    saving: costumeState.saving
  };
}

export default connect(mapStateToProps, {
  addCostumeToScene,
  fetchCostumes,
  clearRedirect
})(AddVisualEffectToScene);
